const video = document.querySelector(".video video");
const pauseIcon = document.querySelector(".pauseVideo");

function pauseVideo() {
    if (pauseIcon) {
        pauseIcon.addEventListener('click', function (event) {
            if (video.paused) {
                video.play();
                pauseIcon.src = "/Content/img/icons/pause.svg";
            }
            else {
                video.pause();
                pauseIcon.src = "/Content/img/icons/play.svg";
            }
        });
    }
}

function disableVideoMobile() {
    if (video) {
        let dataSrc = video.dataset.src;
        if (dataSrc != null || data.src != undefined) {
            if (window.innerWidth > 991) {
                video.src = dataSrc;
            }
        }
    }
}

pauseVideo();
document.addEventListener("DOMContentLoaded", function () {
    disableVideoMobile();
});
